export const goToStep = (history, step) => {
  if (step === 'Solicitud') {
    history.push({ pathname: '/issuance', state: { step: 1 } });
  } else if (step === 'Pendiente Pago') {
    history.push({ pathname: '/issuance', state: { step: 2 } });
  } else if (step === 'Pendiente Firma') {
    history.push({ pathname: '/issuance', state: { step: 3 } });
  }
};
